
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/energy",
      function () {
        return require("private-next-pages/expertise/energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/energy"])
      });
    }
  